export default {
    hasNamesColumn: false,
    rows: {
        'name': {
            valueCells: [{
                unit: '',
                type: 'text',
                editable: false,
                styleClasses: 'borderless bold left-aligned',
                getComputedValue(tabs, precomputedValues) {
                    const value = tabs['property-information-tab'].tables['general-information'].rows['property-name'].value;
                    return {internalValue: value, displayValue: `${value}`};
                },
            }]
        },
        'date': {
            valueCells: [{
                unit: '',
                type: 'date',
                editable: false,
                styleClasses: 'borderless bold left-aligned',
                getComputedValue(tabs, precomputedValues) {
                    const analysisDate = tabs['pricing-tab'].tables['pricing-analysis'].rows['pricing-analysis'].valueCells[1].value;
                    let months = ["January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"];
                    const value = analysisDate ? new Date(analysisDate) : '';
                    const displayValue = value ? `${months[value.getMonth()]} ${value.getFullYear()}` : '';
                    return {internalValue: value, displayValue: `${displayValue.toLocaleString()}`};
                }
            },
            {
                unit: '',
                type: 'date',
                editable: false,
                styleClasses: 'borderless bold left-aligned',
                getComputedValue(tabs, precomputedValues) {
                    const analysisDate = tabs['pricing-tab'].tables['pricing-analysis'].rows['pricing-analysis'].valueCells[2].value;
                    let months = ["January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"];
                    const value = analysisDate ? new Date(analysisDate) : '';
                    const displayValue = value ? `${months[value.getMonth()]} ${value.getFullYear()}` : '';
                    return {internalValue: value, displayValue: `${displayValue.toLocaleString()}`};
                }
            }]
        }
    },
}
